import ajax from '../snippet/ajax';

const ajaxTimeline = () => {
  const $container = $('.js--timeline-posts-container');

  if ($container.length) {
    ajax('kalendarium', 'timeline-post');
  }
};

export default ajaxTimeline;
